import React, { useState } from 'react';
import { parseAmount, formatAmountInput } from '../utils/currencyInput';
export default function MoneyInput({value='',onChange,onFocus,onBlur,...props}) {
 const [focused,setFocused]=useState(false),[draft,setDraft]=useState('');
 return <input {...props} data-no-autoformat="true" type="text" inputMode="decimal" value={focused?draft:(value==null||value===''?'':formatAmountInput(value))}
 onFocus={event=>{setDraft(value==null?'':String(value));setFocused(true);onFocus?.(event);}}
 onChange={event=>{const raw=event.target.value;setDraft(raw);const canonical=raw.trim()===''?'':String(parseAmount(raw));onChange?.({target:{value:canonical},currentTarget:{value:canonical}});}}
 onBlur={event=>{setFocused(false);onBlur?.(event);}}/>;
}
